/**
 * Loader component
 */
import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Observable, Subject, Subscription } from 'rxjs';
import { selectLoader } from '../../ngrx/selectors/ui.selector';
import { Store } from '@ngrx/store';

@Component({
    selector: 'xux-loader',
    templateUrl: './xux-loader.component.html',
    styleUrls: ['./xux-loader.component.scss']
})
export class XUXLoaderComponent implements OnInit, OnDestroy {
    readonly trailDelays = Array.from({ length: 19 }, (_, i) => (i + 1) * 0.02);

    getTrailFill(index: number): string {
        const intensity = Math.round(90 - (index * 60 / 18));   // Calculate intensity from 90% to 30%
        return `color-mix(in srgb, var(--primary-color) ${intensity}%, white)`;
    }

    @Input() loaderState: Observable<any>;
    @Input() contentLoader: boolean;
    @Input() isCancelButtonExist: boolean = false;

    public isVisible: boolean = false;
    protected isActive = true;
    public loaderSubscription: Subscription;
    private dispose$ = new Subject();
    public loader$: Observable<boolean>;

    constructor(private store: Store) {}

    public ngOnInit() {
        this.loader$ = this.store.select(selectLoader);
        this.loaderSubscription = this.loader$.subscribe(state => {
            this.isVisible = !!state;
        });
    }

    public ngOnDestroy() {
        this.isVisible = false;
        this.loaderSubscription.unsubscribe();
        this.dispose$.next();
        this.dispose$.complete();
    }
}
